/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { format, parseISO, set } from 'date-fns';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { MdClose } from 'react-icons/md';
import * as Yup from 'yup';
import Swal from 'sweetalert2';

import { IoIosArrowDown } from 'react-icons/io';
import { formatPrice } from '~/utils/format';
import getValidationErros from '~/utils/getValidationsErrors';
import api from '~/services/api';

import { Container, Modal } from './styles';
import Input from '~/components/Input';
import Contracts from './Contracts';

import loan from '~/assets/defaults/avatar-amount.png';
import dots from '~/assets/defaults/two-dots.svg';
import Toast from '~/utils/toast';
import Totalizers from '~/components/Totalizers';

interface IContractResponse {
  id: string;
  loan_amount: number;
  date: string;
  return: number;
  payment_amount: number;
  payment_date: string;
  maturity_date: string;
}

interface ILenderResponse {
  id: string;
  name: string;
  email: string;
  address: string;
  contracts: IContractResponse[];
}

export interface IContract {
  id: string;
  loanAmount: string;
  totalRepay: string;
  contractDate: Date;
  returnPercentage: string;
  paymentAmount: string;
  paymentDate: string;
  maturityDate: Date;
}

interface ITableData {
  id: string;
  name: string;
  email: string;
  address: string;
  contracts: IContract[];
}

const Lenders: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const [show, setShow] = useState(false);
  const [isAddNewLender, setIsAddNewLender] = useState(true);
  const [tableData, setTableData] = useState<ITableData[]>([]);
  const [lenderSelected, setLenderSelected] = useState({} as ITableData);
  const [contracts, setContracts] = useState<IContract[]>([
    {
      id: new Date().getTime().toString(),
      loanAmount: '',
      totalRepay: '',
      contractDate: new Date(),
      returnPercentage: '',
      paymentAmount: '',
      paymentDate: '',
      maturityDate: new Date(),
    },
  ]);
  const [showSub, setShowSub] = useState('');

  useEffect(() => {
    api.get<ILenderResponse[]>('/lenders').then((response) => {
      const data = response.data.map<ITableData>((lender) => {
        const contractsData = lender.contracts.map<IContract>((contract) => ({
          id: contract.id,
          loanAmount: formatPrice(contract.loan_amount),
          totalRepay: formatPrice(
            contract.loan_amount +
              (contract.loan_amount / 100) * contract.return
          ),
          contractDate: parseISO(contract.date),
          returnPercentage: contract.return.toString(),
          paymentAmount: formatPrice(contract.payment_amount),
          paymentDate: contract.payment_date,
          maturityDate: parseISO(contract.maturity_date),
        }));
        return {
          id: lender.id,
          name: lender.name,
          email: lender.email,
          address: lender.address,
          contracts: contractsData,
        };
      });

      setTableData(data);
    });
  }, []);

  const handleClose = useCallback(() => {
    setShow(false);
    setLenderSelected({} as ITableData);
    setContracts([
      {
        id: new Date().getTime().toString(),
        loanAmount: '',
        totalRepay: '',
        contractDate: new Date(),
        returnPercentage: '',
        paymentAmount: '',
        paymentDate: '',
        maturityDate: new Date(),
      },
    ]);
  }, []);

  const handleSubmit = useCallback(
    async (data) => {
      try {
        formRef.current?.setErrors({});
        const schema = Yup.object().shape({
          name: Yup.string().required('Name is a required'),
          email: Yup.string()
            .email('Email Address must be a valid email')
            .required('Email Address is a required'),
          password: Yup.string().required('Password is a required'),
          address: Yup.string().required('Address is a required'),
          ...contracts.reduce((previous, contract) => {
            const newSchema = previous;
            newSchema[`loanAmount_${contract.id}`] = Yup.string().required(
              'Loan amount is a required'
            );
            newSchema[`contractDate_${contract.id}`] = Yup.string().required(
              'Contract date is a required'
            );
            newSchema[`returnPercentage_${contract.id}`] =
              Yup.string().required('Return is a required');
            newSchema[`paymentAmount_${contract.id}`] = Yup.string().required(
              'Payment amount is a required'
            );
            newSchema[`paymentDate_${contract.id}`] = Yup.string().required(
              'Payment date is a required'
            );
            newSchema[`maturityDate_${contract.id}`] = Yup.string().required(
              'Maturity date is a required'
            );
            return newSchema;
          }, {} as { [key: string]: Yup.StringSchema<string | undefined, Record<string, any>, string | undefined> }),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        const formData = {
          name: data.name,
          email: data.email,
          password: data.password,
          address: data.address,
        };

        const response = await api.post('/lenders', formData);

        const contractsAux: IContract[] = [];
        for (const contract of contracts) {
          const contractFormData = {
            lender_id: response.data.id,
            loan_amount: parseFloat(
              contract.loanAmount.replace('$', '').replaceAll(',', '')
            ),
            date: contract.contractDate,
            return: contract.returnPercentage,
            payment_amount: parseFloat(
              contract.paymentAmount.replace('$', '').replaceAll(',', '')
            ),
            payment_date: contract.paymentDate,
            maturity_date: contract.maturityDate,
          };

          const responseContract = await api.post(
            '/contracts',
            contractFormData
          );

          contractsAux.push({
            id: responseContract.data.id,
            loanAmount: contract.loanAmount,
            totalRepay: formatPrice(
              contractFormData.payment_amount +
                (contractFormData.payment_amount / 100) *
                  parseFloat(contract.returnPercentage)
            ),
            contractDate: contract.contractDate,
            returnPercentage: contract.returnPercentage,
            paymentAmount: contract.paymentAmount,
            paymentDate: contract.paymentDate,
            maturityDate: contract.maturityDate,
          });
        }

        setTableData((oldState) => [
          ...oldState,
          {
            id: response.data.id,
            name: data.name,
            email: data.email,
            address: data.address,
            contracts: contractsAux,
          },
        ]);

        Toast.fire({
          icon: 'success',
          iconColor: '#202020',
          title: 'Lender created successfully',
        });

        handleClose();
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErros(error);
          formRef.current?.setErrors(errors);
        } else {
          Swal.fire(
            'Opss...',
            'There was an error signing in, check credentials',
            'error'
          );
        }
      }
    },
    [contracts, handleClose]
  );

  const handleSubmitUpdate = useCallback(
    async (data) => {
      try {
        formRef.current?.setErrors({});
        const schema = Yup.object().shape({
          name: Yup.string().required('Name is a required'),
          email: Yup.string()
            .email('Email Address must be a valid email')
            .required('Email Address is a required'),
          password: Yup.string(),
          address: Yup.string().required('Address is a required'),
          ...contracts.reduce((previous, contract) => {
            const newSchema = previous;
            newSchema[`loanAmount_${contract.id}`] = Yup.string().required(
              'Loan amount is a required'
            );
            newSchema[`contractDate_${contract.id}`] = Yup.string().required(
              'Contract date is a required'
            );
            newSchema[`returnPercentage_${contract.id}`] =
              Yup.string().required('Return is a required');
            newSchema[`paymentAmount_${contract.id}`] = Yup.string().required(
              'Payment amount is a required'
            );
            newSchema[`paymentDate_${contract.id}`] = Yup.string().required(
              'Payment date is a required'
            );
            newSchema[`maturityDate_${contract.id}`] = Yup.string().required(
              'Maturity date is a required'
            );
            return newSchema;
          }, {} as { [key: string]: Yup.StringSchema<string | undefined, Record<string, any>, string | undefined> }),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        const formData = {
          name: data.name,
          email: data.email,
          password: data.password,
          address: data.address,
        };

        await api.put(`lenders/${lenderSelected.id}`, formData);

        const deletedContracts = lenderSelected.contracts.filter(
          (contract) => !contracts.find((c) => c.id === contract.id)
        );

        const newContracts = contracts.filter(
          (contract) =>
            !lenderSelected.contracts.find((c) => c.id === contract.id)
        );

        const updatedContracts = contracts.filter((contract) =>
          lenderSelected.contracts.find((c) => c.id === contract.id)
        );

        for (const contract of deletedContracts) {
          await api.delete(`contracts/${contract.id}`);
        }

        const contractsAux: IContract[] = [];
        for (const contract of newContracts) {
          const contractFormData = {
            lender_id: lenderSelected.id,
            loan_amount: parseFloat(
              contract.loanAmount.replace('$', '').replaceAll(',', '')
            ),
            date: contract.contractDate,
            return: contract.returnPercentage,
            payment_amount: parseFloat(
              contract.paymentAmount.replace('$', '').replaceAll(',', '')
            ),
            payment_date: contract.paymentDate,
            maturity_date: contract.maturityDate,
          };

          const responseContract = await api.post(
            '/contracts',
            contractFormData
          );

          contractsAux.push({
            id: responseContract.data.id,
            loanAmount: contract.loanAmount,
            totalRepay: formatPrice(
              contractFormData.payment_amount +
                (contractFormData.payment_amount / 100) *
                  parseFloat(contract.returnPercentage)
            ),
            contractDate: contract.contractDate,
            returnPercentage: contract.returnPercentage,
            paymentAmount: contract.paymentAmount,
            paymentDate: contract.paymentDate,
            maturityDate: contract.maturityDate,
          });
        }

        for (const contract of updatedContracts) {
          const contractFormData = {
            lender_id: lenderSelected.id,
            loan_amount: parseFloat(
              contract.loanAmount.replace('$', '').replaceAll(',', '')
            ),
            date: contract.contractDate,
            return: contract.returnPercentage,
            payment_amount: parseFloat(
              contract.paymentAmount.replace('$', '').replaceAll(',', '')
            ),
            payment_date: contract.paymentDate,
            maturity_date: contract.maturityDate,
          };

          await api.put(`/contracts/${contract.id}`, contractFormData);
        }

        const lenders = tableData.slice();

        const lendersIndex = lenders.findIndex(
          (lender) => lender.id === lenderSelected.id
        );

        if (lendersIndex >= 0) {
          lenders[lendersIndex].name = data.name;
          lenders[lendersIndex].email = data.email;
          lenders[lendersIndex].address = data.address;
          lenders[lendersIndex].contracts = [
            ...updatedContracts,
            ...contractsAux,
          ];
        }

        setTableData(lenders);

        handleClose();
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErros(error);
          formRef.current?.setErrors(errors);
        } else {
          Swal.fire(
            'Opss...',
            'There was an error signing in, check credentials',
            'error'
          );
        }
      }
    },
    [
      contracts,
      handleClose,
      lenderSelected.contracts,
      lenderSelected.id,
      tableData,
    ]
  );

  const handleLender = useCallback(
    (index) => {
      setIsAddNewLender(false);
      setShow(true);
      const data = tableData[index];

      setLenderSelected(data);
      setContracts(data.contracts);
    },
    [tableData]
  );

  const handleAddContract = useCallback(() => {
    setContracts((oldState) => [
      ...oldState,
      {
        id: new Date().getTime().toString(),
        loanAmount: '',
        totalRepay: '',
        contractDate: new Date(),
        returnPercentage: '',
        paymentAmount: '',
        paymentDate: '',
        maturityDate: new Date(),
      },
    ]);
  }, []);

  const handleChangeContracts = useCallback((contractsData) => {
    setContracts(contractsData);
  }, []);

  const handleClickRow = useCallback(
    (lender) => {
      if (lender.id === showSub) {
        setShowSub('');
      } else {
        setShowSub(lender.id);
      }
    },
    [showSub]
  );

  return (
    <Container>
      <div className="container">
        <div className="row">
          <div className="col-12 px-4 py-5 px-lg-5">
            <Totalizers />
            <div className="row">
              <div className="d-none d-lg-block col-12 header-table mb-3">
                <div className="row">
                  <div className="col-2">
                    <h2>Lender Name</h2>
                  </div>
                  <div className="col">
                    <h2>Loan Amount</h2>
                  </div>
                  <div className="col">
                    <h2>Total To Repay</h2>
                  </div>
                  <div className="col">
                    <h2>Contract Date</h2>
                  </div>
                  <div className="col">
                    <h2>Return %</h2>
                  </div>
                  <div className="col">
                    <h2>Payment Amount</h2>
                  </div>
                  <div className="col">
                    <h2>Payment Date</h2>
                  </div>
                  <div className="col">
                    <h2>Maturity Date</h2>
                  </div>
                </div>
              </div>
              {tableData.map((data, index) => (
                <>
                  <div
                    className={`col-12 row-lg-table mb-3 ${
                      data.contracts.length > 1 ? 'btn text-start' : ''
                    }`}
                    onClick={() => handleClickRow(data)}
                  >
                    <div className="row">
                      <div className="col-12 d-lg-none header-table text-center mb-3">
                        <h2>Lender Name </h2>
                      </div>
                      <div className="row-md-table col-12 col-lg-2 mb-3 mb-lg-0">
                        <h3 className=" d-flex align-items-center">
                          <img
                            width={52}
                            height={52}
                            src={loan}
                            alt="Loan"
                            className="me-lg-3"
                          />
                          <span className="loan-amount">{data.name}</span>
                        </h3>
                      </div>
                      <div className="col-12 d-lg-none header-table text-center mb-3">
                        <h2>Loan Amount</h2>
                      </div>
                      <div className="row-md-table col-12 col-lg d-flex align-items-center mb-3 mb-lg-0">
                        <h3 className="mx-auto mx-lg-0 padding">
                          {data.contracts[0].loanAmount}
                        </h3>
                      </div>
                      <div className="col-12 d-lg-none header-table text-center mb-3">
                        <h2>Total To Repay</h2>
                      </div>
                      <div className="row-md-table col-12 col-lg d-flex align-items-center mb-3 mb-lg-0">
                        <h3 className="mx-auto mx-lg-0 padding">
                          {data.contracts[0].totalRepay}
                        </h3>
                      </div>
                      <div className="col-12 d-lg-none header-table text-center mb-3">
                        <h2>Contract Date</h2>
                      </div>
                      <div className="row-md-table col-12 col-lg d-flex align-items-center mb-3 mb-lg-0">
                        <h3 className="mx-auto mx-lg-0 padding">
                          {format(data.contracts[0].contractDate, 'MM/dd/yy')}
                        </h3>
                      </div>
                      <div className="col-12 d-lg-none header-table text-center mb-3">
                        <h2>Return %</h2>
                      </div>
                      <div className="row-md-table col-12 col-lg d-flex align-items-center mb-3 mb-lg-0">
                        <h3 className="mx-auto mx-lg-0 padding">
                          Principal + {data.contracts[0].returnPercentage}%
                        </h3>
                      </div>
                      <div className="col-12 d-lg-none header-table text-center mb-3">
                        <h2>Payment Amount</h2>
                      </div>
                      <div className="row-md-table col-12 col-lg d-flex align-items-center mb-3 mb-lg-0">
                        <h3 className="mx-auto mx-lg-0 padding">
                          {data.contracts[0].paymentAmount}
                        </h3>
                      </div>
                      <div className="col-12 d-lg-none header-table text-center mb-3">
                        <h2>Payment Date</h2>
                      </div>
                      <div className="row-md-table col-12 col-lg d-flex align-items-center mb-3 mb-lg-0">
                        <h3 className="mx-auto mx-lg-0 padding">
                          {data.contracts[0].paymentDate}
                        </h3>
                      </div>
                      <div className="col-12 d-lg-none header-table text-center mb-3">
                        <h2>Maturity Date</h2>
                      </div>
                      <div className="row-md-table col-12 col-lg d-flex align-items-center">
                        <h3 className="mx-auto mx-lg-0 padding">
                          {format(data.contracts[0].maturityDate, 'MM/dd/yy')}
                        </h3>
                        <button
                          type="button"
                          onClick={() => handleLender(index)}
                          className="border-0 bg-transparent ms-3"
                        >
                          <img src={dots} alt="Dots" />
                        </button>
                        {data.contracts.length > 1 && (
                          <IoIosArrowDown
                            className={`arrow ${
                              showSub === data.id ? 'open' : 'close'
                            }`}
                          />
                        )}
                      </div>
                      <div className="col-12 d-lg-none">
                        <hr className="px-5" />
                      </div>
                    </div>
                  </div>
                  {data.contracts.length > 1 && (
                    <div className={showSub === data.id ? 'd-block' : 'd-none'}>
                      {data.contracts.map((contract, idx) => (
                        <>
                          {idx > 0 && (
                            <div className="col-12 sub-row-table row-lg-table mb-3 ms-auto">
                              <div className="row">
                                <div className="col-12 d-lg-none header-table text-center mb-3">
                                  <h2>Lender Name </h2>
                                </div>
                                <div className="row-md-table col-12 col-lg-2 mb-3 mb-lg-0">
                                  <h3 className=" d-flex align-items-center">
                                    <img
                                      width={0}
                                      height={52}
                                      src={loan}
                                      alt="Loan"
                                      className="me-lg-3 opacity-0"
                                    />
                                    <span className="loan-amount">
                                      Contract {idx + 1}
                                    </span>
                                  </h3>
                                </div>
                                <div className="col-12 d-lg-none header-table text-center mb-3">
                                  <h2>Loan Amount</h2>
                                </div>
                                <div className="row-md-table col-12 col-lg d-flex align-items-center mb-3 mb-lg-0">
                                  <h3 className="mx-auto mx-lg-0 padding">
                                    {contract.loanAmount}
                                  </h3>
                                </div>
                                <div className="col-12 d-lg-none header-table text-center mb-3">
                                  <h2>Total To Repay</h2>
                                </div>
                                <div className="row-md-table col-12 col-lg d-flex align-items-center mb-3 mb-lg-0">
                                  <h3 className="mx-auto mx-lg-0 padding">
                                    {contract.totalRepay}
                                  </h3>
                                </div>
                                <div className="col-12 d-lg-none header-table text-center mb-3">
                                  <h2>Contract Date</h2>
                                </div>
                                <div className="row-md-table col-12 col-lg d-flex align-items-center mb-3 mb-lg-0">
                                  <h3 className="mx-auto mx-lg-0 padding">
                                    {format(contract.contractDate, 'MM/dd/yy')}
                                  </h3>
                                </div>
                                <div className="col-12 d-lg-none header-table text-center mb-3">
                                  <h2>Return %</h2>
                                </div>
                                <div className="row-md-table col-12 col-lg d-flex align-items-center mb-3 mb-lg-0">
                                  <h3 className="mx-auto mx-lg-0 padding">
                                    Principal + {contract.returnPercentage}%
                                  </h3>
                                </div>
                                <div className="col-12 d-lg-none header-table text-center mb-3">
                                  <h2>Payment Amount</h2>
                                </div>
                                <div className="row-md-table col-12 col-lg d-flex align-items-center mb-3 mb-lg-0">
                                  <h3 className="mx-auto mx-lg-0 padding">
                                    {contract.paymentAmount}
                                  </h3>
                                </div>
                                <div className="col-12 d-lg-none header-table text-center mb-3">
                                  <h2>Payment Date</h2>
                                </div>
                                <div className="row-md-table col-12 col-lg d-flex align-items-center mb-3 mb-lg-0">
                                  <h3 className="mx-auto mx-lg-0 padding">
                                    {contract.paymentDate}
                                  </h3>
                                </div>
                                <div className="col-12 d-lg-none header-table text-center mb-3">
                                  <h2>Maturity Date</h2>
                                </div>
                                <div className="row-md-table col-12 col-lg d-flex align-items-center">
                                  <h3 className="mx-auto mx-lg-0 padding">
                                    {format(contract.maturityDate, 'MM/dd/yy')}
                                  </h3>
                                </div>
                                <div className="col-12 d-lg-none">
                                  <hr className="px-5" />
                                </div>
                              </div>
                            </div>
                          )}
                        </>
                      ))}
                    </div>
                  )}
                </>
              ))}

              <div className="col-12 text-end pe-lg-0">
                <button
                  type="button"
                  className="btn-new "
                  onClick={() => {
                    setShow(true);
                    setIsAddNewLender(true);
                  }}
                >
                  Add New
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal className="" centered size="lg" show={show} onHide={handleClose}>
        <div className="text-end">
          <button
            type="button"
            className="border-0 bg-transparent me-3 mt-3 mb-n4"
          >
            <MdClose color="#000" size={24} onClick={handleClose} />
          </button>
        </div>
        <Modal.Header className="border-0 justify-content-center pt-3">
          <h2 className="text-center">
            {isAddNewLender ? 'Add New Lender' : 'Lender Information'}
          </h2>
        </Modal.Header>
        <Modal.Body className="px-5">
          <Form
            ref={formRef}
            className=""
            initialData={lenderSelected}
            onSubmit={isAddNewLender ? handleSubmit : handleSubmitUpdate}
            id="join-waitlist-modal"
          >
            <div className="container">
              <div className="row">
                <div className="col-lg-6 mb-4">
                  <h3>Lender Name</h3>
                  <Input name="name" type="text" className="bd-input" />
                </div>
                <div className="col-lg-6 mb-4">
                  <h3>Email</h3>
                  <Input name="email" type="email" className="bd-input" />
                </div>
                <div className="col-lg-4 mb-4">
                  <h3>Password</h3>
                  <Input name="password" type="text" className="bd-input" />
                </div>
                <div className="col-lg-8 mb-4">
                  <h3>Address</h3>
                  <Input name="address" type="text" className="bd-input" />
                </div>

                <Contracts
                  contracts={contracts}
                  onChange={handleChangeContracts}
                />
                {!isAddNewLender && (
                  <div className="col-12 text-center mt-4">
                    <button
                      type="button"
                      className="border-0 bg-transparent btn-new-contract"
                      onClick={handleAddContract}
                    >
                      Add New Contract
                    </button>
                  </div>
                )}
                <button
                  type="submit"
                  className={` d-flex align-items-center justify-content-center mt-4 btn btn-submit`}
                >
                  {isAddNewLender ? 'Create New Lender' : 'SAVE'}
                </button>
              </div>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer className="border-0 my-2" />
      </Modal>
    </Container>
  );
};

export default Lenders;
